import { Aux } from './AuxillaryServices';
import { $ } from '../../vendor/jquery';
import _ from 'underscore';

function QueryManager() {
    var _t = this;

    _t.queryable = {};

    _t.registerQueryableObject = function (kind, selector, callback) {
        if (typeof _t.queryable[kind] === 'undefined') {
            _t.queryable[kind] = [];
        }

        _t.queryable[kind].push({
            selector: selector,
            callback: callback,
        });
    };

    _t.executeQuery = function (query) {
        var match = /^select (.*) from (.*) where (.*)$/.exec(query);
        if (match && typeof match[1] !== 'undefined') {
            if (_t.queryable[match[2]]) {
                var q = _.chain(_t.queryable[match[2]])
                    .select(function (queryable) {
                        return queryable.selector == match[3];
                    })
                    .first()
                    .value();

                if (q) {
                    return q.callback(match[1]);
                } else {
                    let dfd = $.Deferred();
                    dfd.reject('no result');
                    return dfd.promise();
                }
            } else {
                let dfd = $.Deferred();
                dfd.reject('no result');
                return dfd.promise();
            }
        } else {
            let dfd = $.Deferred();
            dfd.reject('invalid query');
            return dfd.promise();
        }
    };
}

let QryMgr = null;

/**
 * @todo document this
 */
function initializeQueryManager() {
    Aux.AddListener(function (event) {
        switch (event) {
            case 'Initialize': {
                if (null === QryMgr) {
                    QryMgr = new QueryManager();
                    Aux.RegisterService('QueryManager', QryMgr);
                }
                break;
            }
        }
    });
}

export { initializeQueryManager };
